var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2549"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 15.5,
    cy: 15.5,
    r: 15,
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 6.5C14.2835 6.5 13.5 7.2835 13.5 8.25V16.75C13.5 17.7165 14.2835 18.5 15.25 18.5C16.2165 18.5 17 17.7165 17 16.75V8.25C17 7.2835 16.2165 6.5 15.25 6.5ZM15.25 20.5C14.2835 20.5 13.5 21.2835 13.5 22.25C13.5 23.2165 14.2835 24 15.25 24C16.2165 24 17 23.2165 17 22.25C17 21.2835 16.2165 20.5 15.25 20.5Z",
    fill: "#131F3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.9e56e3367d1690ddf84fd45326b5de32.svg";
export { ForwardRef as ReactComponent };